module.exports = __webpack_public_path__ + "img/checkin.4720c457.png";